<template>
  <div class="survey-content survey-liuhe">
    <el-table
      id="survey_liuhe_area-table"
      size="medium"
      :max-height="height"
      :data="data"
    >
      <el-table-column
        show-overflow-tooltip
        label="调查时间"
        prop="takenAt"
        width="100"
        align="center"
      >
        <template slot-scope="prop">
          {{ prop.row.takenAt | formatDate('YYYY-MM-DD') }}
        </template>
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="测报点"
        prop="site"
        min-width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="寄主类型"
        prop="host"
        width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="寄主生育期"
        prop="hostCycle"
        width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="测报对象"
        prop="insect"
        width="120"
        align="center"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="发生面积"
        prop="area"
        align="center"
        min-width="120"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="虫口密度"
        prop="density"
        align="center"
        min-width="100"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="有虫株率"
        prop="percent"
        align="center"
        min-width="100"
        :formatter="row => `${row.percent}%`"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="备注"
        prop="description"
        align="center"
        min-width="100"
      ></el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="经度"
        prop="lng"
        width="80"
        align="center"
      >
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="纬度"
        prop="lat"
        width="80"
        align="center"
      >
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="创建"
        prop="createdBy"
        width="80"
        align="center"
      >
      </el-table-column>

      <el-table-column
        show-overflow-tooltip
        label="创建时间"
        prop="createdAt"
        width="140"
        align="center"
      >
        <template slot-scope="prop">
          {{ prop.row.createdAt | formatDate }}
        </template>
      </el-table-column>

      <el-table-column align="center" fixed="right" width="80" label="操作">
        <template slot-scope="prop">
          <el-tooltip content="附件" placement="top-start">
            <el-button type="text" @click="showImages(prop.row)">
              <svg-icon iconClass="pin"></svg-icon>
            </el-button>
          </el-tooltip>

          <el-tooltip content="删除" placement="top-start">
            <el-button type="text" @click="getDel(prop.row)">
              <svg-icon iconClass="trash"></svg-icon>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="margin-t16">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="limit"
        :current-page="page"
        @current-change="goPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { list, remove } from '@/service/survey'
import showImgDetail from '@/components/ImgManager/common'
import { formatDate } from '@/utlis/date'

export default {
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      limit: 50,
      total: 0,
      pagerHeight: 64,
      height: 600
    }
  },
  beforeMount() {
    this.layout()
  },
  mounted() {
    this.getData()
  },
  methods: {
    layout() {
      let el = document.getElementsByClassName('page-survey')[0]
      this.height = el.offsetHeight - this.pagerHeight
    },
    async getData(page = 1) {
      this.loading = true
      const params = { page, limit: this.limit }
      const { data, code } = await list(this.companyId, 'liuhe-area', params)
      if (code) {
        this.data = data.data
        this.total = data.paging.count
        if (+this.page !== +data.paging.page) {
          this.page = data.paging.page
        }
      }
      this.loading = false
    },
    showImages({ takenAt, insect, site, files }) {
      if (!files) {
        return this.$message.error('找不到附件！')
      }

      const urls = files.split(',')
      const title = `发生量调查 / ${formatDate(
        takenAt,
        'YYYY-MM-DD'
      )} / ${site} / ${insect}`
      const list = urls.map((url, id) => ({ id, src: url, title }))
      showImgDetail({ id: 0, list })
    },
    async getDel({ id, takenAt, insect, site }) {
      try {
        await this.$confirm(
          `将要删除 <strong>调查时间：${formatDate(
            takenAt,
            'YYYY-MM-DD'
          )}，测报对象：${insect}，测报点：${site}</strong>, 是否继续？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        )
        await remove('liuhe-area', id)
        let index = this.data.findIndex(d => d.id === id)
        this.data.splice(index, 1)
      } catch {
        this.$message({ type: 'info', message: '取消删除' })
      }
    },
    goPage(page) {
      this.getData(page)
    }
  }
}
</script>
